<template>
  <div id="app">
    <ListErrorMessages :appErrors="appErrors" />
    <CommercialErrorReport />
  </div>
</template>

<script>
import ListErrorMessages from '@/components/errors/list';
import CommercialErrorReport from '@/pages/commercialerrorreport';

export default {
  components: { ListErrorMessages, CommercialErrorReport },
  data() {
    return {
      appErrors: [],
    };
  },

  created() {
    console.log('CREATED');
  },

  /**
   * Presentera felmeddelande för fel som uppstår
   */
  errorCaptured(err, component, info) {
    if (err.constructor.name != 'Error' || err.response == undefined) return;

    if (err.response.status !== 401) this.appErrors.push(err);
  },
};
</script>
